import WarningIcon from './component.jsx'
export default WarningIcon



// WEBPACK FOOTER //
// ./src/components/WarningIcon/index.js